import Helper from '@ember/component/helper';
import { scheduleOnce, cancel } from '@ember/runloop';

class UseEffectHelper extends Helper {
  timeout = null;

  compute([fn, ...args]) {
    this.timeout = scheduleOnce('afterRender', this, this.run, fn, args);
  }

  run(fn, args) {
    this.timeout = null;
    fn(...args);
  }

  willDestroy() {
    super.willDestroy();
    cancel(this.timeout);
  }
}

export default UseEffectHelper;
